import React, { useState, useEffect, useRef } from "react";
import { fetchJson } from "../../lib/Fetching";
import Button from "../Button";
import QuotablesGroup from "./QuotablesGroup";
import useVisibilitySensor from "@rooks/use-visibility-sensor";

export default function DisplayQuotables({
  quoteItemIds,
  sample_id,
  hideInitially,
  hide = true,
}) {
  const [quotables, setQuotables] = useState(null);
  const [loadingStarted, setLoadingStarted] = useState(false);
  const [hidden, setHidden] = useState(hide);

  const rootNode = useRef(null);
  const { isVisible, visibilityRect } = useVisibilitySensor(rootNode, {
    intervalCheck: false,
    scrollCheck: true,
    resizeCheck: true,
  });

  const fetchQuotables = () => {
    return fetchJson("/quoting/quotables", {
      quote_item_ids: quoteItemIds,
      sample_id,
    }).then(({ quotables }) => {
      setQuotables(quotables);
    });
  };

  useEffect(
    () => {
      if (!hidden && isVisible && !quotables && !loadingStarted) {
        setLoadingStarted(true);
        fetchQuotables();
      }
    },
    [quoteItemIds, sample_id, hidden, isVisible]
  );

  const renderHidden = () =>
    hidden ? (
      <div>
        <Button title="Show quote items" onClick={() => setHidden(!hidden)} small />
      </div>
    ) : null;

  // if (hidden) {
  //   return (
  //     <div>
  //       <Button title="Show quote items" onClick={() => setHidden(!hidden)} small />
  //     </div>
  //   );
  // }

  const renderLoading = () =>
    !hidden && !quotables ? (
      <div style={{ paddingTop: 10 }}>
        <i className="fa fa-spinner fa-spin" />
        &nbsp;
      </div>
    ) : null;

  // if (!hidden && !quotables) {
  //   return (
  //     <div style={{ paddingTop: 10 }}>
  //       <i className="fa fa-spinner fa-spin" />
  //       &nbsp;
  //     </div>
  //   );
  // }
  // if (!quotables) return null;

  return (
    <div ref={rootNode}>
      {renderHidden()}
      {renderLoading()}
      {quotables && (
        <QuotablesGroup
          hideSearch
          quotables={quotables}
          selectedIds={[]}
          onChangeIds={(ids) => {}}
        />
      )}
    </div>
  );
}
